export type StepItemProps = {
  order: number;
  title: string;
  subtitle: string;
  progress: number;
  isActive: boolean;
  onClick: () => void;
};

export function ProcessStepsCarouselDesktopItem({
  order,
  title,
  subtitle,
  isActive,
  progress,
  onClick,
}: StepItemProps) {
  return (
    <div className="group">
      <div
        className="relative cursor-pointer transition-all duration-300 border-l-2 border-transparent"
        onClick={onClick}
      >
        <div className="absolute left-0 top-0 w-px h-full flex flex-col items-center">
          <div className="w-px bg-white/50 h-5 group-first:bg-transparent" />
          <span className="block w-4 h-4 text-xs leading-4 text-center text-white font-medium">
            {order}
          </span>
          <div className={`grow bg-white/50 w-px ${!isActive ? 'group-last:bg-transparent' : ''}`}>
            {isActive && (
              <div
                className="w-px bg-white transition-all duration-100 ease-linear"
                style={{ height: `${progress}%` }}
              />
            )}
          </div>
        </div>

        <div
          className={`pl-8 transition-opacity duration-300 text-white flex flex-col gap-4 ${isActive ? 'opacity-100' : 'opacity-30'}`}
        >
          <div
            className="text-[52px] *:text-[52px] font-serif *:font-serif tracking-[-0.96px] *:tracking-[-0.96px] leading-[120%] *:leading-[120%] font-semibold *:font-semibold"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {isActive && (
            <>
              <div
                className="text-xl *:text-xl leading-[130%] *:leading-[1.3] tracking-[-0.4px] *:tracking-[-0.4px] pb-21"
                dangerouslySetInnerHTML={{ __html: subtitle }}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
